var GAME_SESSION_NAMESPACE = 'game-session';
var SET_BETS_PLACED = 'SET_BETS_PLACED';
var SET_BET_WINS = 'SET_BET_WINS';
var SET_SESSION_START = 'SET_SESSION_START';
var SET_GAME_SESSION = 'SET_GAME_SESSION';

export { GAME_SESSION_NAMESPACE, SET_BETS_PLACED, SET_BET_WINS, SET_GAME_SESSION, SET_SESSION_START };
